import { ChangeDetectorRef } from '@angular/core';
import { registerBulkAction, addNavMenuSection } from '@vendure/admin-ui/core';
import {
    assignPromotionsToChannelBulkAction,
    deleteSpinPromosBulkAction,
    duplicatePromotionsBulkAction,
    removePromotionsFromChannelBulkAction,
} from './components/spin-promos-list/spin-promos-list-bulk-actions';
import { deleteSpinRewardsDealsBulkAction } from './components/spin-rewards-list/spin-rewards-list-bulk-actions';

export default [
    addNavMenuSection({
        id: 'spin-promotions',
        label: 'Spin Promotions',
        requiresPermission: 'SpinRewardsControl',
        items: [
            {
                id: 'spin-promos-list',
                label: 'Spin Promos',
                routerLink: ['/extensions/spin-promos/list'],
                icon: 'event',
            },
            {
                id: 'spin-rewards-list',
                label: 'Spin Rewards List',
                routerLink: ['/extensions/spin-promos/rewards'],
                icon: 'eye',
            },
        ],
    }),

    registerBulkAction(deleteSpinPromosBulkAction),
    registerBulkAction(assignPromotionsToChannelBulkAction),
    registerBulkAction(removePromotionsFromChannelBulkAction),
    registerBulkAction(duplicatePromotionsBulkAction),

    registerBulkAction(deleteSpinRewardsDealsBulkAction),
];
